import { useState } from "react";
import useSetQuery from "./useQuery";
import { useDispatch } from "react-redux";
import { generateFilterPayload } from "helpers/emeaHelpers";
// import { generateFilterPayload as generateFilterPayloadLao } from "helpers/laoHelpers";
import { isEmpty } from "lodash";
import { useEMEAGlobalContext } from "context/EMEAGlobalContext";
import { useLAOGlobalContext } from "context/LAOGlobalContext";
import { useDeepCompareEffect } from "react-use";

export const useRefreshTable = ({
    fetchEndPoint,
    tableName,
    type,
    controller,
    getTableData,
    tableBody,
    setPage: setParentPageSize
}) => {
    const {
        locations,
        customers,
        sofcs,
        BU,
        documentDate
    } = useEMEAGlobalContext();

    const dispatch = useDispatch();
    const [params] = useSetQuery();
    const [pageParams, setPageParams] = useState({ page: 0, pageSize: 15 });

    const tableFilters = params.emeaFilters;

    const refreshTable = ({ pageSize, page }) => {
        const updatedSitesFilter = isEmpty(tableFilters?.originSites) ? { ...tableFilters, originSites: locations } : tableFilters;
        const updatedDocDateFilter = tableName === "invoiceSummary" ? 
            { ...tableFilters, documentDate: isEmpty(tableFilters?.documentDateFilter) ? tableBody?.documentDateFilter : tableFilters?.documentDateFilter } : {};

        const reqBody = {
            controller,
            body: {
                fetchEndPoint,
                tablebody: {
                    ...tableBody,
                    ...updatedSitesFilter,
                    documentDate,
                    businessUnits: BU,
                    customerOrSalesOffice: [...customers, ...sofcs],
                    ...updatedDocDateFilter
                },
                pageSize,
                page,
                tableName,
                type
            },
            language: localStorage.getItem('i18nextLng')
        }
        dispatch(getTableData(reqBody));
    }

    useDeepCompareEffect(() => {
        if (!params.loadView) {
            refreshTable({ ...pageParams, page: 0 });
            setParentPageSize(0);
        }
    }, [tableFilters, documentDate, BU, customers, sofcs, locations, params.loadView]);

    const updatePageParams = ({ page, pageSize }) => {
        setPageParams({ page, pageSize });
        refreshTable({ page, pageSize });
    }

    return [updatePageParams, refreshTable]
}

export const useRefreshTableLAO = ({
    fetchEndPoint,
    tableName,
    type,
    controller,
    getTableData,
    subType,
    defaultFilters,
    setPage: setParentPageSize
}) => {
    const {
        locations,
        BU,
        language
    } = useLAOGlobalContext();

    const tableBody = {
        region: 'LAO',
        searchType: subType,
        ...(generateFilterPayload(defaultFilters)),
    };

    const dispatch = useDispatch();
    const [params] = useSetQuery();
    const [pageParams, setPageParams] = useState({ page: 0, pageSize: 10 });

    const tableFilters = params.laoFilters;
    const sitesObj = {
      EXPORT_ORDER_DETAILS: 'originSites',
      LAO_EXPORT_DRP: 'originSites',
      IMPORT_ORDER_DETAILS: 'destSites',
      LAO_EXPORT_LOAD_PLAN: 'originSites'
    };
    const sites = sitesObj[subType];

    const refreshTable = ({ pageSize, page }) => {
        const updatedFilters = isEmpty(tableFilters?.originSites) ? { ...tableFilters, [sites]: locations } : tableFilters;

        const reqBody = {
            controller,
            body: {
                fetchEndPoint,
                tablebody: {
                    ...tableBody,
                    ...updatedFilters,
                    businessUnits: BU
                },
                pageSize,
                page,
                tableName,
                type
            },
            language: localStorage.getItem('i18nextLng')
        }
        dispatch(getTableData(reqBody));
    }

    useDeepCompareEffect(() => {
        if (!params.loadView) {
            refreshTable({ ...pageParams, page: 0 });
            setParentPageSize(0);
        }
    }, [tableFilters, BU, locations, params.loadView, language]);

    const updatePageParams = ({ page, pageSize }) => {
        setPageParams({ page, pageSize });
        refreshTable({ page, pageSize });
    }

    return [updatePageParams, refreshTable]
}

